const blogManager = () => {
  // TODO: toggle visibility and feature flag for blogs
  // look at backend videos.schema.js, videos.router.js, and videos.service.js for an example
  // etc..
  return <h1>blogs</h1>
}

export default blogManager;